export default function BusTour() {
  return (
    <div data-testid="london-bus-parade" className="relative overflow-hidden py-4 select-none" aria-hidden="true">
      <div className="relative h-28">
        <svg className="cloud cloud-a" viewBox="0 0 80 40" width="70" height="35">
          <ellipse cx="28" cy="28" rx="22" ry="11" fill="#EAF3FB" />
          <ellipse cx="48" cy="22" rx="18" ry="12" fill="#EAF3FB" />
        </svg>
        <svg className="cloud cloud-b" viewBox="0 0 80 40" width="52" height="26">
          <ellipse cx="26" cy="28" rx="20" ry="10" fill="#F0F7FD" />
          <ellipse cx="44" cy="22" rx="16" ry="11" fill="#F0F7FD" />
        </svg>

        <div className="bus-drive absolute left-0 bottom-3">
          <div className="bus-bob">
            <svg width="190" height="92" viewBox="0 0 190 92">
              <rect x="6" y="14" width="178" height="56" rx="15" fill="#E8564A" />
              <rect x="6" y="14" width="178" height="10" rx="5" fill="#F2735F" />
              <rect x="88" y="6" width="52" height="12" rx="6" fill="#FFF4CC" stroke="#E8564A" strokeWidth="2" />
              <text x="114" y="15" textAnchor="middle" fontSize="7.5" fontWeight="800" fill="#31435C" fontFamily="Outfit, sans-serif">BAILEY TOURS</text>
              <rect x="16" y="28" width="30" height="20" rx="5" fill="#FFFDF2" />
              <rect x="52" y="28" width="30" height="20" rx="5" fill="#FFFDF2" />
              <rect x="88" y="28" width="30" height="20" rx="5" fill="#FFFDF2" />
              <rect x="124" y="28" width="30" height="20" rx="5" fill="#FFFDF2" />
              <circle cx="31" cy="37" r="5.5" fill="#8D5A3B" />
              <circle cx="67" cy="37" r="5.5" fill="#C98A5E" />
              <circle cx="103" cy="37" r="5.5" fill="#6B4226" />
              <path d="M28 39.5 q3 2.5 6 0" stroke="#31435C" strokeWidth="1" fill="none" strokeLinecap="round" />
              <path d="M64 39.5 q3 2.5 6 0" stroke="#31435C" strokeWidth="1" fill="none" strokeLinecap="round" />
              <path d="M100 39.5 q3 2.5 6 0" stroke="#31435C" strokeWidth="1" fill="none" strokeLinecap="round" />
              <rect x="158" y="26" width="22" height="26" rx="5" fill="#FFFDF2" />
              <rect x="161" y="29" width="16" height="12" rx="3" fill="#BFE0F7" />
              <rect x="14" y="54" width="162" height="9" rx="4" fill="#FFF4CC" opacity="0.85" />
              <text x="95" y="61" textAnchor="middle" fontSize="7" fontWeight="700" fill="#31435C" fontFamily="Outfit, sans-serif">LEARN WITH BAILEY · LONDON</text>
              <circle cx="180" cy="48" r="3.5" fill="#FFE9A8" />
              <g className="wheel">
                <circle cx="48" cy="72" r="13" fill="#31435C" />
                <circle cx="48" cy="72" r="5" fill="#FFFDF2" />
                <line x1="48" y1="61" x2="48" y2="83" stroke="#FFFDF2" strokeWidth="2" />
                <line x1="37" y1="72" x2="59" y2="72" stroke="#FFFDF2" strokeWidth="2" />
              </g>
              <g className="wheel">
                <circle cx="142" cy="72" r="13" fill="#31435C" />
                <circle cx="142" cy="72" r="5" fill="#FFFDF2" />
                <line x1="142" y1="61" x2="142" y2="83" stroke="#FFFDF2" strokeWidth="2" />
                <line x1="131" y1="72" x2="153" y2="72" stroke="#FFFDF2" strokeWidth="2" />
              </g>
            </svg>
          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0 border-t-4 border-dashed border-sand" />
      </div>
    </div>
  );
}
